<template>
    <p class="d-inline-flex"> 
    <v-list color="transparent" class="ma-0 pa-0">
        <v-list-item class="ma-0 pa-0">
            <v-list-item-avatar class="my-0 py-0" v-bind:class="{primary: displayImageUrl ==''}" :style="`background-position: center;background-repeat: no-repeat;background-size: cover;background-size: cover;background-image: url('${ displayImageUrl }')`">
                <v-icon v-if="displayImageUrl ==''" dark>person</v-icon>
            </v-list-item-avatar>
        </v-list-item>
    </v-list>
    <v-card elevation="0" class="info">
        <v-card-title class="text-subtitle-1 font-weight-bold">
            {{ comment.fullName }}<span class="accent--text ml-2 font-weight-regular">&nbsp;- <timeago :datetime="Date.parse(comment.createdAt.toDate())" :auto-update="60"></timeago></span>
        </v-card-title>
        <v-card-text class="mt-n2 black--text">
            {{ comment.text }}
        </v-card-text>
    </v-card>
    </p>
</template>
<script>


import {getDownloadUrlForRef, getStorageRef} from "@/shared/firebase_utils";

export default {
    name: 'CommentViewer',
     props: {
        comment: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            displayImageUrl: '',
        };
    },
    async created() {
        let displayImageUrl = '';

        let assetLocation ='';
        if (this.comment.uid || '' != '') {
            assetLocation = `userDisplayImages/${this.comment.uid}.png`;
        }
        if (this.comment.businessProfileId || '' != '') {
            assetLocation = `premiereProfileLogos/${this.comment.businessProfileId}.png`;
        }
        if (assetLocation != '') {
            await getDownloadUrlForRef(getStorageRef(assetLocation)).then((url) => {
                displayImageUrl = url.toString();
            }).catch(function(error) {
                //No display image found
            });
        }
        this.displayImageUrl = displayImageUrl;
    },
}
</script>